export default "__VITE_ASSET__6CN157EX__"